import { signal, Signal } from '@preact/signals'
import { Symbology, SymbologyDescription } from '@scandit/web-datacapture-barcode'
import type { Extension } from './modeSymbologies'

export class Option {
  public checked: Signal<boolean>

  constructor(initialValue = false) {
    this.checked = signal(initialValue)
    this.toggle = this.toggle.bind(this)
    this.activate = this.activate.bind(this)
    this.deactivate = this.deactivate.bind(this)
  }

  toggle() {
    this.checked.value = !this.checked.value
    return this.checked.value
  }

  activate() {
    this.checked.value = true
    return true
  }

  deactivate() {
    this.checked.value = false
    return false
  }
}

export class SymbologyOption extends Option {
  public symbology: Symbology
  public description: SymbologyDescription

  constructor(symbology: Symbology, initialValue = false) {
    super(initialValue)
    this.symbology = symbology
    this.description = new SymbologyDescription(symbology)
  }
}

export class SymbologyOptionExtension extends Option {
  public extension: Extension
  constructor(extension: Extension, initialValue = false) {
    super(initialValue)
    this.extension = extension
  }
}
